import AddPaymentDialogV2 from '~/components/dashboard/invoices/payment/add-payment-dialog-v2/components/AddPaymentDialogV2'
import { PaymentDialogProvider } from '~/components/dashboard/invoices/payment/add-payment-dialog-v2/context/PaymentDialogProvider'
import type { InvoiceOrEstimate } from '~/types'

export interface AddPaymentDialogContainerV2Props {
  invoice: InvoiceOrEstimate
  isEstimate?: boolean
  isFromAddPaymentFlow?: boolean
  isOpen: boolean
  onClose: () => void
  refetchInvoice?: () => void
  showStepper?: boolean
}

const AddPaymentDialogContainerV2 = ({
  isOpen,
  onClose,
  invoice,
  isEstimate,
  refetchInvoice,
  showStepper = false,
  isFromAddPaymentFlow = false,
}: AddPaymentDialogContainerV2Props) => (
  <PaymentDialogProvider
    invoice={invoice}
    isEstimate={isEstimate}
    isFromAddPaymentFlow={isFromAddPaymentFlow}
    refetchInvoice={refetchInvoice}
  >
    <AddPaymentDialogV2
      isOpen={isOpen}
      showStepper={showStepper}
      onClose={onClose}
    />
  </PaymentDialogProvider>
)

export default AddPaymentDialogContainerV2
